import { __assign, __read, __spread } from "tslib";
import { addGlobalEventProcessor, SDK_VERSION } from '@sentry/browser';
function createReactEventProcessor() {
    if (addGlobalEventProcessor) {
        addGlobalEventProcessor(function (event) {
            event.sdk = __assign(__assign({}, event.sdk), { name: 'sentry.javascript.react', packages: __spread(((event.sdk && event.sdk.packages) || []), [
                    {
                        name: 'npm:@sentry/react',
                        version: SDK_VERSION,
                    },
                ]), version: SDK_VERSION });
            return event;
        });
    }
}
export * from '@sentry/browser';
export { Profiler, withProfiler, useProfiler } from './profiler';
export { ErrorBoundary, withErrorBoundary } from './errorboundary';
createReactEventProcessor();
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sentry/react/esm/index.js
// module id = 296
// module chunks = 0